var noUiSlider = require('noUiSlider');

module.exports = ['$rootScope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
    var subcategory_desc_options = window.MG.subcategory_desc_options;
    var third_level_sort_options = window.MG.third_level_sort_options;
    var manufacturer_options = window.MG.manufacturer_options;

    var thirdLevelSorts = [];
    var manufacturers = [];

    // this is duplicated for now
    var initializeSelectFacet = function (facetName, facetOptions, defaultOption) {
        var facetSetName = facetName + 'Set';
        var resetToDefault = true;

        // build an array of all options that should be in dropdown
        $scope[facetSetName] = [];
        angular.forEach(facetOptions, function (x) {
            if (typeof (x) === 'object') {
                $scope[facetSetName].push(x);
            } else {
                $scope[facetSetName].push({
                    name: x.replace('-', ' '),
                    id: x.toLowerCase()
                });
            }
        });

        // adds in a default option as first item in dropdown
        if (typeof (defaultOption) === 'object' && defaultOption !== null) {
            $scope[facetSetName].unshift(defaultOption);
        }

        // set the dropdown based on url otherwise just use the first option
        if (typeof ($stateParams[facetName]) !== 'undefined') {
            angular.forEach($scope[facetSetName], function (value, index) {
                if ($stateParams[facetName] === value.id) {
                    $scope[facetName] = $scope[facetSetName][index];
                    resetToDefault = false;
                }
            });
        }
        if (resetToDefault) {
            $scope[facetName] = $scope[facetSetName][0];
        }
    };

    var requiresUpdate = false;

    // initialize dropdowns
    initializeSelectFacet('category', subcategory_desc_options);

    angular.forEach(third_level_sort_options, function (g) {
        if (g.category === $scope.category.name) {
            angular.forEach(g.items, function (item) {
                thirdLevelSorts.push(item);
            });
        }
    });

    angular.forEach(manufacturer_options, function (g) {
        if (g.category === $scope.category.name) {
            angular.forEach(g.items, function (item) {
                manufacturers.push(item);
            });
        }
    });

    initializeSelectFacet('subcategory', thirdLevelSorts, { name: 'All', id: null });
    initializeSelectFacet('manufacturer', manufacturers, { name: 'All', id: null });

    // handle dropdowns
    $scope.selectedDropdown = function (facetName) {
        return $scope[facetName].name;
    };

    $scope.changeDropdown = function ($event, facetName, id) {
        $event.preventDefault();
        $stateParams[facetName] = id;
        if (facetName === 'category') {
            $stateParams.subcategory = undefined;
            $stateParams.manufacturer = undefined;
        }
        window.localStorage.setItem('MG.previousCount', '0');
        $state.go('search', $stateParams, { reload: true });
    };
}];
